import React from 'react';
import {useDispatch} from 'react-redux';

import {ListHeader, Loading} from 'components';

import {downloadResult} from './redux/thunks';
import {useModal} from './hooks';

import AddOrganizationModal from './AddOrganizationModal';
import OrganizationList from './OrganizationList';
import i18n from 'i18next';
import {useData} from './hooks';

function OrganizationPage() {
  const {data, loading} = useData();

  const {showModal, selectedOrganization, onShowModal, onClick} =
    useModal(data);

  const dispatch = useDispatch();

  const onDownload = () => {
    dispatch(downloadResult(''));
  };

  return (
    <>
      <ListHeader
        header={i18n.t('manageOrganizationPage.organisationsLabel')}
        onDownload={onDownload}
        onAdd={onClick()}
      />
      {loading && <Loading />}
      {!loading && <OrganizationList data={data} onClick={onClick} />}
      <AddOrganizationModal
        show={showModal}
        onClose={onShowModal}
        selectedOrganization={selectedOrganization}
      />
    </>
  );
}

export default OrganizationPage;
